import { create } from "zustand";

import type {
  ZPipelineSettingsAction,
  ZPipelineSettingsState,
} from "../types/zustand";

import { pipelineSettingsActionSlice } from "./actionSlice";
import { pipelineSettingsSlice } from "./slice";

export const usePipelineSettingsStore = create<
  ZPipelineSettingsState & ZPipelineSettingsAction
>()((...args) => ({
  ...pipelineSettingsSlice(...args),
  ...pipelineSettingsActionSlice(...args),
}));
